module.exports = __webpack_public_path__ + "assets/img/projects_item_bgimg_left.f2e00ca6.png";